module.exports = __webpack_public_path__ + "static/media/logo.cc11cf39.svg";


//////////////////
// WEBPACK FOOTER
// /src/images/logo.svg
// module id = 1175
// module chunks = 0